/**
 * @author spidersharma / http://eduperiment.com/
 */
import * as THREE from "../../../../libs/three.js/build/three.module.js";
import {Pass, ShaderPass} from './ShaderPass'
import CopyShader from './CopyShader'


let OutlinePass = function ( selectedObjects ) {

	/* scene = scene;
	camera = camera; */
	this.selectedObjects = selectedObjects !== undefined ? selectedObjects : [];
	this.visibleEdgeColor = new THREE.Color( 1, 1, 1 );
	this.hiddenEdgeColor = new THREE.Color( 0.1, 0.04, 0.02 );
	this.edgeGlow = 0.0;
	this.usePatternTexture = false;
	//this.edgeThickness = 1.0;
	this.edgeStrength =  50;
	this.downSampleRatio = 1//2;  // 抗锯齿  值越低renderTarget size越大，抗锯齿越强，线条可越细（或许可以把模糊化去掉？）
	this.pulsePeriod = 0;
    this.showHiddenPart = false //是否判断被遮住的部分，以设置hiddenEdgeColor。一般不需要
	Pass.call( this );

	this.resolution =  new THREE.Vector2( 256, 256 ); 

	var pars = { minFilter: THREE.LinearFilter, magFilter: THREE.LinearFilter, format: THREE.RGBAFormat };

	var resx = Math.round( this.resolution.x / this.downSampleRatio );
	var resy = Math.round( this.resolution.y / this.downSampleRatio );

	 
	this.renderTargetMaskBuffer = new THREE.WebGLRenderTarget( this.resolution.x, this.resolution.y, pars );
	this.renderTargetMaskBuffer.texture.name = "OutlinePass.mask";
	this.renderTargetMaskBuffer.texture.generateMipmaps = false;

	this.depthMaterial = new THREE.MeshDepthMaterial();
	this.depthMaterial.side = THREE.DoubleSide;
	this.depthMaterial.depthPacking = THREE.RGBADepthPacking;
	this.depthMaterial.blending = THREE.NoBlending;

	this.prepareMaskMaterial = this.getPrepareMaskMaterial();
	this.prepareMaskMaterial.side = THREE.DoubleSide;
	 

	this.renderTargetDepthBuffer = new THREE.WebGLRenderTarget( this.resolution.x, this.resolution.y, pars );
	this.renderTargetDepthBuffer.texture.name = "OutlinePass.depth";
	this.renderTargetDepthBuffer.texture.generateMipmaps = false;

	 

	this.edgeDetectionMaterial = this.getEdgeDetectionMaterial(this.edgeStrength);
     
    
	this.renderTargetEdgeBuffer1 = new THREE.WebGLRenderTarget( resx, resy, pars );
	this.renderTargetEdgeBuffer1.texture.name = "OutlinePass.edge1";
	this.renderTargetEdgeBuffer1.texture.generateMipmaps = false;
	 
	// Overlay material
	this.overlayMaterial = this.getOverlayMaterial();

	// copy material 
	this.copyUniforms = THREE.UniformsUtils.clone( CopyShader.uniforms );
	this.copyUniforms[ "opacity" ].value = 1.0;

	this.materialCopy = new THREE.ShaderMaterial( {
		uniforms: this.copyUniforms,
		vertexShader: CopyShader.vertexShader,
		fragmentShader: CopyShader.fragmentShader,
		blending: THREE.NoBlending,
		depthTest: false,
		depthWrite: false,
		transparent: true
	} );

     


	this.enabled = true;
	this.needsSwap = false;

	this.oldClearColor = new THREE.Color();
	this.oldClearAlpha = 1;

	this.camera = new THREE.OrthographicCamera( - 1, 1, 1, - 1, 0, 1 );
	this.scene = new THREE.Scene();

	this.quad = new THREE.Mesh( new THREE.PlaneBufferGeometry( 2, 2 ), null );
	this.quad.frustumCulled = false; // Avoid getting clipped
	this.scene.add( this.quad );
 
	this.textureMatrix = new THREE.Matrix4();

	viewer.addEventListener('viewerResize',(e)=>{
        let size = viewer.renderer.getSize(new THREE.Vector2)
        this.renderTargetEdgeBuffer1.setSize(size.x, size.y );
		this.renderTargetMaskBuffer.setSize(size.x, size.y); 
        this.resolution.set(size.x, size.y)  
    })

};

OutlinePass.prototype = Object.assign( Object.create(  Pass.prototype ), {

	constructor: OutlinePass,

	dispose: function () {

		this.renderTargetMaskBuffer.dispose();
        this.renderTargetEdgeBuffer1.dispose();
        this.renderTargetDepthBuffer.dispose(); 
	},
    
    replaceDepthToViewZ( camera ) {  
		var type = camera.isPerspectiveCamera ? 'perspective' : 'orthographic';
        if(type == this.lastCameraType )return
        this.lastCameraType = type
        this.prepareMaskMaterial.fragmentShader = this.prepareMaskMaterial.fragmentShader.replace( /DEPTH_TO_VIEW_Z/g, type + 'DepthToViewZ' );
		this.prepareMaskMaterial.needsUpdate = true

	},
	setSize: function ( width, height ) {
          
	}, 

	changeVisibilityOfSelectedObjects: function ( bVisible ) {

		function gatherSelectedMeshesCallBack( object ) {

			/* if ( object.isMesh ) { */
            if ( object.isPointcloud || object.isMesh || object.isLine || object.isSprite ) {
				/* if ( bVisible ) {

					object.visible = object.userData.oldVisible;
					delete object.userData.oldVisible;

				} else {

					object.userData.oldVisible = object.visible;
					object.visible = bVisible;

				} */
                Potree.Utils.updateVisible(object, 'overlinePass', bVisible)
			}

		}

		for ( var i = 0; i < this.selectedObjects.length; i ++ ) {

			var selectedObject = this.selectedObjects[ i ];
			selectedObject.traverse( gatherSelectedMeshesCallBack );

		}

	},

	changeVisibilityOfNonSelectedObjects: function ( bVisible , scenes) {

		var selectedMeshes = [];

		function gatherSelectedMeshesCallBack( object ) {

			//if ( object.isMesh ) selectedMeshes.push( object );
            if ( object.isPointcloud || object.isMesh || object.isLine || object.isSprite ) {
                selectedMeshes.push( object );
            }
            

		}

		for ( var i = 0; i < this.selectedObjects.length; i ++ ) {

			var selectedObject = this.selectedObjects[ i ];
			selectedObject.traverse( gatherSelectedMeshesCallBack );

		}

		function VisibilityChangeCallBack( object ) {

			if ( object.isPointcloud || object.isMesh || object.isLine || object.isSprite ) {

				var bFound = false;

				for ( var i = 0; i < selectedMeshes.length; i ++ ) {

					var selectedObjectId = selectedMeshes[ i ].id;

					if ( selectedObjectId === object.id ) {

						bFound = true;
						break;

					}

				}

				if ( ! bFound ) { 
					 
                    var visibility = object.visible;
                    Potree.Utils.updateVisible(object, 'overlinePass', bVisible) //add 
                    
                    //但保不齐在设置为false后，渲染时又true了，所以在其他地方update时设置visible 得用updateVisible
                     
        
                    if(!bVisible){
                        object.visible = false
                    }else{
                        object.visible = !!object.bVisible
                    }


                    object.bVisible = visibility; 
                    
                    
                    //这两种updateVisible 和 visible 设置都不能去掉， 第一块是为了防止有的visible不是通过updateVisible设置的； 第二块是为了防止渲染时updateVisible又修改了visible为true, 另外渲染时
                    
                    return {stopContinue:true} //for pointcloud
                     
				}
                
			}
            
		}
        
        scenes.forEach(scene=>scene.traverse( VisibilityChangeCallBack ))
		

	}, 
     
	updateTextureMatrix: function (camera) {

		this.textureMatrix.set( 0.5, 0.0, 0.0, 0.5,
			0.0, 0.5, 0.0, 0.5,
			0.0, 0.0, 0.5, 0.5,
			0.0, 0.0, 0.0, 1.0 );
		this.textureMatrix.multiply( camera.projectionMatrix );
		this.textureMatrix.multiply( camera.matrixWorldInverse );

	},

	render: function (scenes, camera, viewports,  renderer, writeBuffer, readBuffer,  maskActive, renderFun ) {
        if(!(scenes instanceof Array))scenes = [scenes]
        
        
        
		if ( this.selectedObjects.length > 0 && this.edgeStrength > 0) {
            
            let render2 = (target, dontRenderRtEDL=true)=>{
                if(renderFun){
                    renderFun({target  , dontRenderRtEDL  })
                }else{
                    renderer.setRenderTarget(target)
                    renderer.clear()
                    scenes.forEach(scene=>renderer.render( scene, camera)) 
                }
            }
	   
			this.oldClearColor.copy( renderer.getClearColor(new THREE.Color) );
			this.oldClearAlpha = renderer.getClearAlpha();
			let oldAutoClear = renderer.autoClear;
            let oldTarget = renderer.getRenderTarget();
			renderer.autoClear = false;

			if ( maskActive ) renderer.context.disable( renderer.context.STENCIL_TEST );
            renderer.setClearColor( 0xffffff, 1 );

			let oldBG = viewer.background, oldBgOpacity = viewer.backgroundOpacity
            viewer.background = new THREE.Color(1,1,1)
            viewer.backgroundOpacity = 1;

            
            if(this.showHiddenPart){ //几乎不会使用
                viewports.forEach(e=>{ 
                    e.oldBeforeRender = e.beforeRender
                    e.beforeRender = ()=>{ 
                        e.oldBeforeRender && e.oldBeforeRender()
                        this.replaceDepthToViewZ( e.camera );
                    }
                }) 
                // Make selected objects invisible
                this.changeVisibilityOfSelectedObjects( false );
                
                scenes.forEach(scene=>{
                    scene.currentBackground = scene.background;
                    scene.background = null;
                    // 1. Draw Non Selected objects in the depth buffer
                    scene.overrideMaterial = this.depthMaterial;    
                }) 
                 
                render2(this.renderTargetDepthBuffer)
                  
                // Make selected objects visible
                this.changeVisibilityOfSelectedObjects( true );

        
                viewports.forEach(e=>{
                    e.beforeRender = ()=>{ 
                        e.oldBeforeRender && e.oldBeforeRender()
                        // Update Texture Matrix for Depth compare
                        this.updateTextureMatrix(e.camera);
                        this.prepareMaskMaterial.uniforms[ "cameraNearFar" ].value = new THREE.Vector2( e.camera.near, e.camera.far );
                    }
                })
                
            }else{
                //不渲染背景 
                scenes.forEach(scene=>{
                    scene.currentBackground = scene.background;
                    scene.background = null; 
                })
            }
            
            let colorType, colors = new Map() , opas = new Map()
            {//绘制选中部分
                // Make non selected objects invisible, and draw only the selected objects, by comparing the depth buffer of non selected objects
                this.changeVisibilityOfNonSelectedObjects( false , scenes);
                 
                scenes.forEach(scene=>{ 
                    scene.overrideMaterial = this.prepareMaskMaterial; 
                })
                
                if(this.showHiddenPart){ 
                    this.prepareMaskMaterial.uniforms[ "depthTexture" ].value = this.renderTargetDepthBuffer.texture;
                    this.prepareMaskMaterial.uniforms[ "textureMatrix" ].value = this.textureMatrix;
                }
                  
                //因为点云不受prepareMaskMaterial作用，所以手动将他们变为黑色不透明 
                viewer.scene.pointclouds.forEach(e=>{  //先将点云透明度变为1，因为点云透明度莫名其妙会影响其r值//
                    colorType = e.material.activeAttributeName
                    e.material.activeAttributeName = 'color'
                    
                    colors.set(e, e.material.color)
                    e.material.color = '#000000';
                    
                    opas.set(e, e.material.opacity)
                    e.material.opacity = 1 
                })
            }
            
            render2(this.renderTargetMaskBuffer)
            
            
            {//恢复 
                viewer.scene.pointclouds.forEach(e=>{
                    e.material.activeAttributeName = colorType 
                    e.material.color = colors.get(e) 
                    e.material.opacity = opas.get(e) 
                })
                
                if(this.showHiddenPart){
                    viewports.forEach((e)=>{e.beforeRender = e.oldBeforeRender})
                }
                
                scenes.forEach(scene=>{ 
                    scene.overrideMaterial = null;
                    scene.background = scene.currentBackground 
                }) 
                viewer.background = oldBG
                viewer.backgroundOpacity = oldBgOpacity
                
                this.changeVisibilityOfNonSelectedObjects( true , scenes);
                
            }


            //检测边缘并绘制
			// 3. Apply Edge Detection Pass
			this.quad.material = this.edgeDetectionMaterial;
			this.edgeDetectionMaterial.uniforms[ "maskTexture" ].value = this.renderTargetMaskBuffer.texture;//this.renderTargetMaskDownSampleBuffer.texture;
			this.edgeDetectionMaterial.uniforms[ "texSize" ].value = new THREE.Vector2(this.resolution.x, this.resolution.y )//new THREE.Vector2( this.renderTargetMaskDownSampleBuffer.width, this.renderTargetMaskDownSampleBuffer.height );
			//this.edgeDetectionMaterial.uniforms[ "texSize" ].value = new THREE.Vector2(this.renderTargetMaskBuffer.width, this.renderTargetMaskBuffer.height)//new THREE.Vector2( this.renderTargetMaskDownSampleBuffer.width, this.renderTargetMaskDownSampleBuffer.height );
            this.edgeDetectionMaterial.uniforms[ "edgeStrength" ].value = this.edgeStrength;
            
            this.edgeDetectionMaterial.uniforms[ "visibleEdgeColor" ].value = this.visibleEdgeColor//this.tempPulseColor1;
			this.edgeDetectionMaterial.uniforms[ "hiddenEdgeColor" ].value = this.hiddenEdgeColor //this.tempPulseColor2;
			
            
             
            
            let buffer
            if ( this.renderToScreen ) {
                this.quad.material.transparent = true
                
                buffer = null 
                renderer.setClearColor( this.oldClearColor, this.oldClearAlpha );  
                render2(null,false) //普通绘制原场景
                
                //绘制到全屏
                let renderSize = renderer.getSize(new THREE.Vector2()); //是client大小
                renderer.setViewport(0, 0, renderSize.x, renderSize.y) //规定视口，影响图形变换（画布的使用范围） 
                renderer.setScissorTest( false );
                  
            }else{
                buffer = readBuffer
                renderer.setClearColor( 0x000000, 0 );
                renderer.clear()
            } 
             
            renderer.setRenderTarget( buffer ) 
            renderer.render( this.scene,  this.camera );    //将边缘覆盖上去
           
           
           
 
            renderer.setRenderTarget(oldTarget) 
			renderer.setClearColor( this.oldClearColor, this.oldClearAlpha );
			renderer.autoClear = oldAutoClear;
            return true
		} 
 

	},

	getPrepareMaskMaterial: function () {
        if(this.showHiddenPart){
            return new THREE.ShaderMaterial( {

                uniforms: {
                    "depthTexture": { value: null },
                    "cameraNearFar": { value: new THREE.Vector2( 0.5, 0.5 ) },
                    "textureMatrix": { value: new THREE.Matrix4() }
                },

                vertexShader: [
                    'varying vec4 projTexCoord;',
                    'varying vec4 vPosition;',
                    'uniform mat4 textureMatrix;',

                    'void main() {',

                    '	vPosition = modelViewMatrix * vec4( position, 1.0 );',
                    '	vec4 worldPosition = modelMatrix * vec4( position, 1.0 );',
                    '	projTexCoord = textureMatrix * worldPosition;',
                    '	gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );',

                    '}'
                ].join( '\n' ),

                fragmentShader: [
                    '#include <packing>',
                    'varying vec4 vPosition;',
                    'varying vec4 projTexCoord;',
                    'uniform sampler2D depthTexture;',
                    'uniform vec2 cameraNearFar;',

                    'void main() {',

                    '	float depth = unpackRGBAToDepth(texture2DProj( depthTexture, projTexCoord ));',
                    '	float viewZ = - DEPTH_TO_VIEW_Z( depth, cameraNearFar.x, cameraNearFar.y );',
                    '	float depthTest = (-vPosition.z > viewZ) ? 1.0 : 0.0;',   //决定是否为hiddenPart
                    '	gl_FragColor = vec4(0.0, depthTest, 1.0, 1.0);',

                    '}'
                ].join( '\n' ) 
            } );//没有绘制部分的颜色是clearColor，255
        }else{
            return new THREE.MeshBasicMaterial({color:'#000000'}) //不检测深度，不判断遮挡
        }

	},

	getEdgeDetectionMaterial: function (edgeStrength) {

		return new THREE.ShaderMaterial( {
            
			uniforms: {
                "edgeStrength": { value: edgeStrength }, 
				"maskTexture": { value: null },
				"texSize": { value: new THREE.Vector2( 10, 10 ) },
				"visibleEdgeColor": { value: new THREE.Vector3( 1.0, 1.0, 1.0 ) },
				"hiddenEdgeColor": { value: new THREE.Vector3( 1.0, 1.0, 1.0 ) },
			},

			vertexShader:
				"varying vec2 vUv;\n\
				void main() {\n\
					vUv = uv;\n\
					gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n\
				}",

			/* fragmentShader:
				"varying vec2 vUv;\
				uniform sampler2D maskTexture;\
				uniform vec2 texSize;\
				uniform vec3 visibleEdgeColor;\
				uniform vec3 hiddenEdgeColor;\
				\
				void main() {\n\
					vec2 invSize = 1.0 / texSize;\
					vec4 uvOffset = vec4(1.0, 0.0, 0.0, 1.0) * vec4(invSize, invSize);\
					vec4 c1 = texture2D( maskTexture, vUv + uvOffset.xy);\
					vec4 c2 = texture2D( maskTexture, vUv - uvOffset.xy);\
					vec4 c3 = texture2D( maskTexture, vUv + uvOffset.yw);\
					vec4 c4 = texture2D( maskTexture, vUv - uvOffset.yw);\
					float diff1 = (c1.r - c2.r)*0.5;\
					float diff2 = (c3.r - c4.r)*0.5;\
					float d = length( vec2(diff1, diff2) );\
					float a1 = min(c1.g, c2.g);\
					float a2 = min(c3.g, c4.g);\
					float visibilityFactor = min(a1, a2);\
					vec3 edgeColor = 1.0 - visibilityFactor > 0.001 ? visibleEdgeColor : hiddenEdgeColor;\
					gl_FragColor = vec4(edgeColor, 1.0) * vec4(d);\
				}" */
                fragmentShader:
				`varying vec2 vUv;
				uniform sampler2D maskTexture;
                uniform float edgeStrength;
				uniform vec2 texSize;
				uniform vec3 visibleEdgeColor;
				uniform vec3 hiddenEdgeColor;
				
				void main() { 
                    const float thickness = 1.0;
                    vec2 invSize = thickness / texSize;
					vec4 uvOffset = vec4(1.0, 0.0, 0.0, 1.0) * vec4(invSize, invSize);
					vec4 c1 = texture2D( maskTexture, vUv + uvOffset.xy);
					vec4 c2 = texture2D( maskTexture, vUv - uvOffset.xy);
					vec4 c3 = texture2D( maskTexture, vUv + uvOffset.yw);
					vec4 c4 = texture2D( maskTexture, vUv - uvOffset.yw);
					float diff1 = (c1.r - c2.r)*0.5;  //检测边缘，
					float diff2 = (c3.r - c4.r)*0.5;
					float d = length( vec2(diff1, diff2) ) * edgeStrength;
					float a1 = min(c1.g, c2.g);
					float a2 = min(c3.g, c4.g);
					float visibilityFactor = min(a1, a2); //检测深度值，是否被遮挡
					vec3 edgeColor = 1.0 - visibilityFactor > 0.001 ? visibleEdgeColor : hiddenEdgeColor;
					//gl_FragColor = vec4(0.0,1.0,0.0,1.0); 
                    gl_FragColor = vec4(edgeColor, 1.0) * vec4(d); 
				}`
		} );
        //为什么vec4(0.0,1.0,1.0,1.0);  显示出来的是rgb(109,255,255) ? 几乎只有绿色通道会影响红色通道

	},

	getSeperableBlurMaterial: function ( maxRadius ) {

		return new THREE.ShaderMaterial( {

			defines: {
				"MAX_RADIUS": maxRadius,
			},

			uniforms: {
				"colorTexture": { value: null },
				"texSize": { value: new THREE.Vector2( 0.5, 0.5 ) },
				"direction": { value: new THREE.Vector2( 0.5, 0.5 ) },
				"kernelRadius": { value: 1.0 }
			},

			vertexShader:
				"varying vec2 vUv;\n\
				void main() {\n\
					vUv = uv;\n\
					gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n\
				}",

			fragmentShader:
				"#include <common>\
				varying vec2 vUv;\
				uniform sampler2D colorTexture;\
				uniform vec2 texSize;\
				uniform vec2 direction;\
				uniform float kernelRadius;\
				\
				float gaussianPdf(in float x, in float sigma) {\
					return 0.39894 * exp( -0.5 * x * x/( sigma * sigma))/sigma;\
				}\
				void main() {\
					vec2 invSize = 1.0 / texSize;\
					float weightSum = gaussianPdf(0.0, kernelRadius);\
					vec3 diffuseSum = texture2D( colorTexture, vUv).rgb * weightSum;\
					vec2 delta = direction * invSize * kernelRadius/float(MAX_RADIUS);\
					vec2 uvOffset = delta;\
					for( int i = 1; i <= MAX_RADIUS; i ++ ) {\
						float w = gaussianPdf(uvOffset.x, kernelRadius);\
						vec3 sample1 = texture2D( colorTexture, vUv + uvOffset).rgb;\
						vec3 sample2 = texture2D( colorTexture, vUv - uvOffset).rgb;\
						diffuseSum += ((sample1 + sample2) * w);\
						weightSum += (2.0 * w);\
						uvOffset += delta;\
					}\
					gl_FragColor = vec4(diffuseSum/weightSum, 1.0);\
				}"  
               
		} );

	},

	getOverlayMaterial: function () {//对边缘线进一步处理，已被废弃

		return new THREE.ShaderMaterial( {

			uniforms: {
				"maskTexture": { value: null },
				"edgeTexture1": { value: null },
				"edgeTexture2": { value: null },
				"patternTexture": { value: null },
				"edgeStrength": { value: 1.0 },
				"edgeGlow": { value: 1.0 },
				"usePatternTexture": { value: 0.0 }
			},

			vertexShader:
				"varying vec2 vUv;\n\
				void main() {\n\
					vUv = uv;\n\
					gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n\
				}",

			/* fragmentShader:
				"varying vec2 vUv;\
				uniform sampler2D maskTexture;\
				uniform sampler2D edgeTexture1;\
				uniform sampler2D edgeTexture2;\
				uniform sampler2D patternTexture;\
				uniform float edgeStrength;\
				uniform float edgeGlow;\
				uniform bool usePatternTexture;\
				\
				void main() {\
					vec4 edgeValue1 = texture2D(edgeTexture1, vUv);\
					vec4 edgeValue2 = texture2D(edgeTexture2, vUv);\
					vec4 maskColor = texture2D(maskTexture, vUv);\
					vec4 patternColor = texture2D(patternTexture, 6.0 * vUv);\
					float visibilityFactor = 1.0 - maskColor.g > 0.0 ? 1.0 : 0.5;\
					vec4 edgeValue = edgeValue1 + edgeValue2 * edgeGlow;\
					vec4 finalColor = edgeStrength * maskColor.r * edgeValue;\       // 删除 * maskColor.r  也就是去掉遮罩，使模型部分也有outline
					if(usePatternTexture)\
						finalColor += + visibilityFactor * (1.0 - maskColor.r) * (1.0 - patternColor.r);\
					gl_FragColor = finalColor;\
				}", */
                fragmentShader:
              `varying vec2 vUv;   
				uniform sampler2D edgeTexture1;   
				uniform float edgeStrength;   
				 
				void main() { 
					gl_FragColor = edgeStrength * texture2D(edgeTexture1, vUv);  
				}`,
			blending: THREE.AdditiveBlending,
			depthTest: false,
			depthWrite: false,
			transparent: true
		} );

	}

} );

OutlinePass.BlurDirectionX = new THREE.Vector2( 1.0, 0.0 );
OutlinePass.BlurDirectionY = new THREE.Vector2( 0.0, 1.0 );

export default OutlinePass






/* 


渲染步骤：（没有showHiddenPart时）

仅绘制选中部分，材质为普通的单色材质，颜色是黑色不透明。未绘制部分的clearColor是白色不透明。
（详见prepareMaskMaterial，输出的r要为0） 
     


然后在上面绘制的图中，根据r的差值，得到边缘线。


正常绘制场景之后，将上面的边缘线覆盖于其上。



（如果showHiddenPart，最开始还要先隐藏选中部分，这是为了得到非选中部分的深度值，然后再绘制选中部分时去比较选中和非选中部分之间的深度差异。以判断是否被遮挡。）








 */
